module.exports = __webpack_public_path__ + "static/media/skin-1.e34cf33c.svg";